import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
  Button,
  Input,
} from "@repo/ui";

type Props = {
  isOpen: boolean;
  mode: "create" | "rename" | "rename-task";
  defaultName?: string;
  isSubmitting?: boolean;
  onClose: () => void;
  onSubmit: (values: { name: string }) => void;
};

export const FolderDialog = ({
  isOpen,
  mode,
  defaultName = "",
  isSubmitting,
  onClose,
  onSubmit,
}: Props) => {
  const [name, setName] = useState(defaultName);

  useEffect(() => {
    if (isOpen) {
      setName(defaultName);
    }
  }, [isOpen, defaultName]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    onSubmit({ name });
  };

  const title =
    mode === "create" ? "Create Task Folder" : mode === "rename" ? "Rename Folder" : "Rename Task";

  const desc =
    mode === "create"
      ? "Enter a name for the new folder."
      : mode === "rename"
        ? "Enter a new name for the folder."
        : "Enter a new name for the task.";

  const disabled = isSubmitting || name === defaultName || !name.trim();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{desc}</DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Folder Name"
            inputSize="sm"
            autoFocus
          />

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button
              type="submit"
              title={disabled ? "Name is same as previous" : undefined}
              disabled={disabled}
            >
              {isSubmitting ? "Saving..." : "Save"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
